import { defineComponent as _defineComponent } from 'vue'
import RmpBtn from "@rmp/core/components/buttons/RmpBtn.vue";
import RmpLink from "@rmp/core/components/common/RmpLink.vue";
import RmpLegalPersonDetails from "@rmp/core/components/details/RmpLegalPersonDetails.vue";
import RmpLegalEntityDetails from "@rmp/core/components/details/RmpLegalEntityDetails.vue";
import RmpMasterAccountAccessApplicationBaseStep from "@rmp/id/views/masterAccountAccess/steps/RmpMasterAccountAccessApplicationBaseStep.vue";
import RmpDigitalSignatureDialog from "@rmp/core/components/digitalSignature/RmpDigitalSignatureDialog.vue";

import { CounterpartyTypeEnum } from "@rmp/core/types/CounterpartyTypeEnum";

import { cloneDeep } from "lodash";
import { processApiPayload } from "@rmp/core/utils/api";

import { useI18n } from "vue-i18n-composable";
import { useMasterAccountAccessSelectCounterpartyStepStore } from "@rmp/id/stores/masterAccountAccess/steps/selectCounterparty";
import { useMasterAccountAccessContactInformationStepStore } from "@rmp/id/stores/masterAccountAccess/steps/contactInformation";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { usePage } from "@rmp/core/composables/usePage";
import { useMasterAccountAccessStore } from "@rmp/id/stores/masterAccountAccess";
import { useMasterAccountAccessSignApplicationStepStore } from "@rmp/id/stores/masterAccountAccess/steps/signApplication";
import { ApiEgrulLegalEntity, ApiEgrulEgripEntrepreneur } from "@rmp/api-gateway";


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpSignApplicationStep',
  setup(__props) {

const { tc } = useI18n();

const applicationStore = useMasterAccountAccessStore();

const useSelectCounterpartyStepStore = useMasterAccountAccessSelectCounterpartyStepStore;
const selectCounterpartyStepStore = useSelectCounterpartyStepStore();
let { counterparty, counterpartyType } = storeToRefs(selectCounterpartyStepStore);

const contactInformationStepStore = useMasterAccountAccessContactInformationStepStore();

const useStore = useMasterAccountAccessSignApplicationStepStore;
const store = useStore();
let { encodedDetachedSignatureString, encodedApplicationString, signed } = storeToRefs(store);
const {} = useStore();

const signatureDialog = ref(false);
const legalEntity = computed(() => counterparty.value as ApiEgrulLegalEntity);
const legalPerson = computed(() => counterparty.value as ApiEgrulEgripEntrepreneur);

const title = computed(() => {
	switch (counterpartyType.value) {
		case CounterpartyTypeEnum.LEGAL_ENTITY:
			return tc("titles.masterAccountAccessApplication.legalEntityCounterpartyType");
		case CounterpartyTypeEnum.LEGAL_PERSON:
			return tc("titles.masterAccountAccessApplication.legalPersonCounterpartyType");
		default:
			return "";
	}
});

const signingPayload = computed(() => {
	let counterpartyData = cloneDeep(counterparty.value);
	
	processApiPayload(counterpartyData);
	
	if(counterpartyType.value === CounterpartyTypeEnum.LEGAL_ENTITY) {
		return JSON.stringify({ legalEntity: counterpartyData, requestorEmail: contactInformationStepStore.email });
	} else {
		return JSON.stringify({ entrepreneur: counterpartyData, requestorEmail: contactInformationStepStore.email });
	}
});

const handleSign = async ({ data, signature }: { data: string, signature: string }) => {
	try {
		encodedApplicationString.value = data;
		encodedDetachedSignatureString.value = signature;
	} catch (e) {
		console.error(e);
	}
};

const { initialized } = usePage({ useStore });

return { __sfc: true,tc, applicationStore, useSelectCounterpartyStepStore, selectCounterpartyStepStore, counterparty, counterpartyType, contactInformationStepStore, useStore, store, encodedDetachedSignatureString, encodedApplicationString, signed, signatureDialog, legalEntity, legalPerson, title, signingPayload, handleSign, initialized, RmpBtn, RmpLink, RmpLegalPersonDetails, RmpLegalEntityDetails, RmpMasterAccountAccessApplicationBaseStep, RmpDigitalSignatureDialog, CounterpartyTypeEnum }
}

})